import { ChartContainer } from "../../../style/style";
import { Line } from "react-chartjs-2";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { PGET, GET } from "../../../api/adminApi";
import { Row } from "antd";
import Select from "react-select";
import CustomDatePicker from "../../common/CustomDatePicker";
import moment from "moment";

export const LineChartMonthly = (props) => {
  const [labels, setLabels] = useState([]);
  const [datasets, setDatasets] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    label: "Секционный",
    value: 1,
  });
  const [dateRange, setDateRange] = useState([
    new Date("2026-01-01"),
    new Date("2027-01-01"),
  ]);
  const [startDate, endDate] = dateRange;
  const [region, setRegion] = useState({ id: 0, name: "Все регионы" });
  const [regions, setRegions] = useState([region]);
  const selectOptions = [
    { label: "Секционный", value: 1 },
    { label: "Панельный", value: 2 },
    { label: "Котел", value: 3 },
  ];

  async function getRegions() {
    const response = await GET("/services/admin/api/region-helper/1");
    if (response?.length > 0) {
      setRegions([region, ...response]);
    }
  }

  async function getItems() {
    const payload = {
      category: selectedOption.value,
      regionId: region.id,
    };
    if (startDate && endDate) {
      payload.dateFrom = moment(startDate).format("YYYY-MM-DD");
      payload.dateTo = moment(endDate).add(1, "day").format("YYYY-MM-DD");
    }
    const data = await PGET("/services/admin/api/dashboard-sales-chart/", true, payload);
    if (data && data.data) {
      const newLabels = data.data.map((item) => item.month + 1);
      setLabels(newLabels);
      const newDataset = [
        {
          label: "Продажа",
          data: data.data.map((item) => item.soldCount),
          borderColor: "#1ce1ac",
          borderWidth: 1,
          fill: false,
        },
      ];
      setDatasets(newDataset);
    }
  }

  const { options, height, width, id } = props;
  const data = {
    labels,
    datasets,
  };
  const maxValue = datasets[0]?.data ? Math.max(...datasets[0].data) * 2 : 0;
  const updatedOptions = {
    ...options,
    scales: {
      y: {
        min: 0,
        max: maxValue,
        ticks: {
          precision: 0,
        },
      },
    },
  };

  useEffect(() => {
    getRegions();
  }, []);

  useEffect(() => {
    getItems();
  }, [startDate, endDate, selectedOption, region]);

  const handleChange = (selected) => {
    setSelectedOption(selected);
  };

  const handleRegionChange = (selected) => {
    setRegion(selected);
  };

  return (
    <div className="line-chart-container">
      <div className="mb-3 d-flex align-items-center justify-content-center">
        <div style={{ backgroundColor: "#1ce1ac", width: 40, height: 13, marginRight: 10 }}></div>
        <span className="fw-bold fs-5">Продажа</span>
      </div>
       <div className="flex justify-end mt-2">
        <div style={{ width: 200, position: "absolute", right: 340, top: 16 }}>
          <CustomDatePicker
            startDate={startDate}
            endDate={endDate}
            onChange={(update) => setDateRange(update)}
            className="datepicker-custom-input-dash"
          />
        </div>
        <div style={{ width: 200, position: "absolute", right: 130, top: 16 }}>
          <Select
            name="regionId"
            className="custom-react-select"
            options={regions}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            value={region}
            style={{ height: 30 }}
            onChange={handleRegionChange}
          />
        </div>
        <div style={{ width: 200, position: "absolute", right: 0, top: 15 }}>
          <Select
            name="category"
            className="custom-react-select"
            options={selectOptions}
            value={selectedOption}
            style={{ height: 30 }}
            onChange={handleChange}
          />
        </div>
      </div>
     
      <ChartContainer className="chart-container">
        <Line
          id={id && id}
          width={width}
          data={data}
          height={height}
          options={updatedOptions}
        />
      </ChartContainer>
    </div>
  );
};

LineChartMonthly.defaultProps = {
  height: 300,
  width: null,
  options: {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
    },
    legend: {
      display: false,
      labels: {
        display: false,
      },
    },
  },
};

LineChartMonthly.propTypes = {
  height: PropTypes.number,
  labels: PropTypes.arrayOf(PropTypes.string),
  datasets: PropTypes.arrayOf(PropTypes.object),
  layout: PropTypes.object,
  width: PropTypes.number,
  options: PropTypes.object,
  id: PropTypes.string,
};
